import { COLLECTIONS } from "constants/action-types";
import { IDoorTotals, IDoorTotalDelta } from "reducers/collection";

export const calcBulkDoorTotalsForMatchingRows = (rows, doors, useAsFilteredTotals?: boolean) => {
    return {
        payload: { rows, doors, useAsFilteredTotals },
        type: COLLECTIONS.COLLECTION.DOOR_TOTALS.CALCULATE_FOR_MATCHING_ROWS,
    };
};

export const calculationsReturnedForMatchingRows = (totals: IDoorTotals, useAsFilteredTotals?: boolean) => ({
    payload: { totals, useAsFilteredTotals },
    type: COLLECTIONS.COLLECTION.DOOR_TOTALS.CALCULATION_RETURNED,
});

export const calculationsFilteredReturnedForMatchingRows = (totals: IDoorTotals) => ({
    payload: { totals },
    type: COLLECTIONS.COLLECTION.DOOR_TOTALS_FILTERED.CALCULATION_RETURNED,
});

export const setDoorTotalDeltaQueue = (doorTotals: IDoorTotalDelta[]) => ({
    payload: { queue: doorTotals },
    type: COLLECTIONS.COLLECTION.DOOR_TOTALS.SET_DOOR_TOTAL_DELTA_QUEUE,
});
